import Footer from "./components/Footer";
import Header from "./components/Header";
import React from "react";
import HomeScreen from "./screens/HomeScreen";
import ProductScreen from "./screens/ProductScreen";
import { Routes, Route } from "react-router-dom";
import CartScreen from "./screens/CartScreen";
import LoginScreen from "./screens/LoginScreen";
import RegisterScreen from "./screens/RegisterScreen";
import ProfileScreen from "./screens/ProfileScreen";
import ShippingScreen from "./screens/ShippingScreen";
import PaymentScreen from "./screens/PaymentScreen";
import PlaceOrderScreen from "./screens/PlaceOrderScreen";
import OrderScreen from "./screens/OrderScreen";
import UserListScreen from "./screens/UserListScreen";
import ProductListScreen from "./screens/ProductListScreen";
import OrderListScreen from "./screens/OrderListScreen";
import UserEditScreen from "./screens/UserEditScreen";
import ProductEditScreen from "./screens/ProductEditScreen";
import CollectionScreen from "./screens/CollectionScreen";
import WishListScreen from "./screens/WishListScreen";

function App() {
  return (
    <>
      <Header />
      <main style={{ marginTop: "80px" }}>
        <WishListScreen />
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/collections/all" element={<CollectionScreen />} />
          <Route path="/search/:keyword" element={<HomeScreen />} />
          <Route
            path="/collections/all/page/:pageNumber"
            element={<CollectionScreen />}
          />
          <Route
            path="/search/:keyword/page/:pageNumber"
            element={<HomeScreen />}
          />
          <Route path="/product/:id" element={<ProductScreen />} />
          <Route path="/cart/:id" element={<CartScreen />} />
          <Route path="/cart" element={<CartScreen />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/register" element={<RegisterScreen />} />
          <Route path="/profile" element={<ProfileScreen />} />
          <Route path="/shipping" element={<ShippingScreen />} />
          <Route path="/payments" element={<PaymentScreen />} />
          <Route path="/placeorder" element={<PlaceOrderScreen />} />
          <Route path="/order/:id" element={<OrderScreen />} />
          <Route path="/admin/userList" element={<UserListScreen />} />
          <Route path="/admin/productList" element={<ProductListScreen />} />
          <Route
            path="/admin/productList/page/:pageNumber"
            element={<ProductListScreen />}
          />
          <Route path="/admin/orderList" element={<OrderListScreen />} />
          <Route path="/admin/user/:id/edit" element={<UserEditScreen />} />
          <Route
            path="/admin/product/:id/edit"
            element={<ProductEditScreen />}
          />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;
